export const CONTENT_ALIGNMENT = 'contentAlignment';
export const CONTENT_ALIGNMENT_MOBILE = 'contentAlignmentMobile';
export const CONTENT_ALIGNMENT_PATH = `style.numbers.${CONTENT_ALIGNMENT}`;
export const CONTENT_ALIGNMENT_MOBILE_PATH = `style.numbers.${CONTENT_ALIGNMENT_MOBILE}`;
export var ContentAlignment;
(function (ContentAlignment) {
    ContentAlignment[ContentAlignment["Left"] = 0] = "Left";
    ContentAlignment[ContentAlignment["Center"] = 1] = "Center";
    ContentAlignment[ContentAlignment["Right"] = 2] = "Right";
})(ContentAlignment || (ContentAlignment = {}));
export const CONTENT_ALIGNMENT_PARAM = {
    wixParam: CONTENT_ALIGNMENT,
    appSettingsPath: CONTENT_ALIGNMENT_PATH,
    defaultAlignment: ContentAlignment.Left,
};
export const CONTENT_ALIGNMENT_MOBILE_PARAM = {
    wixParam: CONTENT_ALIGNMENT_MOBILE,
    appSettingsPath: CONTENT_ALIGNMENT_MOBILE_PATH,
    defaultAlignment: ContentAlignment.Left,
};
//# sourceMappingURL=content-alignment.js.map